import apiCallTemplate from './servicesConfig'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const pricingURL = `${BASE_URL}/prices`;

export const allPricingPlans=async ()=>apiCallTemplate("get", pricingURL)

//create Pricing plan
export const createPricingPlan=async (data)=>apiCallTemplate("post", pricingURL, data)

//*******TO BE DELETED!!!!!!! */
export const createOpenPricingPlan=async (data)=>apiCallTemplate("post", "/create", data)

//Get pricing plan by id
export const getPricingPlan=async (id)=>apiCallTemplate("get", `${pricingURL}/${id}`)

//Update pricing plan 
export const updatePricingPlan=async (id, data)=>apiCallTemplate("put", `${pricingURL}/${id}`, data)

//Delete pricing plan
export const deletePricingPlan=async (id)=>apiCallTemplate("delete", `${pricingURL}/${id}`)
